import { LP_EXPRESS_2_BETA_FLAG } from "@shared/schema";

export type LpExpressSurface = "lp-express-1" | "lp-express-2";

export const LP_EXPRESS_2_ROUTE = {
  path: "/brands/:brandId/landing-pages-express-2",
  surface: "lp-express-2",
  gate: {
    flag: LP_EXPRESS_2_BETA_FLAG,
  },
} as const;

export function withLpExpressSurfaceUrl(
  url: string,
  surface: LpExpressSurface,
): string {
  if (surface === "lp-express-1") return url;
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}surface=${encodeURIComponent(surface)}`;
}

export function withLpExpressSurfacePayload<T>(
  payload: T,
  surface: LpExpressSurface,
): T | (T & { surface: "lp-express-2" }) {
  if (
    surface === "lp-express-1" ||
    payload === null ||
    typeof payload !== "object" ||
    Array.isArray(payload)
  ) {
    return payload;
  }
  return { ...payload, surface: "lp-express-2" };
}